import { OMNI_LIGNE_MEJ_DATA } from './app/common/const/omni-ligne-mej-data';
(window as any).OMNI_LIGNE_MEJ_DATA = OMNI_LIGNE_MEJ_DATA;
